import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin, map, Observable, switchMap } from 'rxjs';
import { StrategyService } from '../services/strategy.service';
import { StrategicPillarService } from '../services/strategic-pillar.service';
import { SocketService } from '../services/socket.service';


export const strategyManagerHomeResolver: ResolveFn<Observable<any>> = (route, state) => {
  const strategyService = inject(StrategyService);
  const strategicPillarService = inject(StrategicPillarService);
  // const socketService = inject(SocketService);
  const strategyId = +route.queryParams['strategyId']

  if (+strategyId) {
    return forkJoin({
      stratgies: strategyService.RawStrategies$,
      strategyAlignment: strategyService.getStrategyAlignment(strategyId.toString()),
      pillars: strategicPillarService.getListPillars(strategyId),
    });
  } else {
    return strategyService.defaultStrategy$.pipe(
      switchMap((defaultStrategy) => {
        const defaultId = defaultStrategy?.id?.toString() || '0';
        return forkJoin({
          stratgies: strategyService.RawStrategies$,
          strategyAlignment: strategyService.getStrategyAlignment(defaultId),
          pillars: strategicPillarService.getListPillars(+defaultId)
        })
      })
    );
  }
}